// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"5fac546d","183":"3a7ea9c1","346":"5fac546d","602":"58e9b024","820":"9d8e2ebf","841":"194d041b","976":"1a4f887b"}[chunkId] + ".chunk.css";
};